<button
  tuiButton
  [appearance]="appearance"
  (click)="download.emit()"
  [showLoader]="!!processing"
><iss-icon name="download" class="tw-mr-[8px]"/><ng-content/></button>
